<template>
    <div class="container">
        <b-modal
            :model-value="showColumna"
            :no-close-on-backdrop="true"
            hide-footer
            centered
            size="lg"
            :title="labels.newColumn"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            @hide="clickClose">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.columna }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input
                            type="number"
                            v-model="columna"
                            class="form-input"
                            :placeholder="labels.columnaPlaceholder"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.columnaName }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input
                            type="text"
                            v-model="columnaName"
                            class="form-input"
                            :placeholder="labels.columnaNamePlaceholder"
                        />
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="clickClose">
                        {{ labels.close }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="saveColumn">
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EcpReporte from '../../services/EcpReporte'

export default {
    name: "NewColumna",
    props: {
        showColumna: {
            type: Boolean,
            default: false
        },
        listaColumnas: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        columna: '',
        columnaName: '',
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    newColumn: "Agregar Columna",
                    infoTitle: "Nueva Columna",
                    infoText: "Ingresa los datos de la nueva columna y guarda los cambios.",
                    columna: "Columna (Números):",
                    columnaPlaceholder: "Ingrese el número de columna (Ej: 1, 2, 3...)",
                    columnaName: "Nombre:",
                    columnaNamePlaceholder: "Ingrese el nombre de la columna",
                    save: "Guardar",
                    close: "Cerrar",
                    duplicateColumn: "La columna ya existe. Ingrese un número de columna diferente.",
                    requiredFields: "Hay campos pendientes por diligenciar"
                }
            } else {
                return {
                    newColumn: "Add Column",
                    infoTitle: "New Column",
                    infoText: "Enter the new column data and save the changes.",
                    columna: "Column (Numbers):",
                    columnaPlaceholder: "Enter column number (Eg: 1, 2, 3...)",
                    columnaName: "Name:",
                    columnaNamePlaceholder: "Enter column name",
                    save: "Save",
                    close: "Close",
                    duplicateColumn: "The column already exists. Enter a different column number.",
                    requiredFields: "There are fields pending completion"
                }
            }
        }
    },
    methods: {
        clickClose() {
            this.$emit('closeModal', false)
        },

        columnaYaExiste(numeroColumna) {
            if (!Array.isArray(this.listaColumnas)) return false
            const numeroStr = String(numeroColumna).trim()
            return this.listaColumnas.some(item => {
                const valorColumna = item?.columna ?? item?.codigo ?? item?.numero
                if (valorColumna === undefined || valorColumna === null) return false
                return String(valorColumna).trim() === numeroStr
            })
        },

        saveColumn() {
            if (this.columna == "" || this.columnaName == "") {
                this.$toast.error(this.labels.requiredFields)
                return
            }

            if (this.columnaYaExiste(this.columna)) {
                this.$toast.error(this.labels.duplicateColumn)
                return
            }

            const dataForm = {
                'columna': this.columna,
                'nombreColumna': this.columnaName,
                'idUser': this.$store.state.userId
            }

            EcpReporte.insertColumna(dataForm)
                .then((res) => {
                    this.$toast.success(res.data.message)
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error(err)
                })
                .finally(() => {
                    setTimeout(() => {
                        this.reloadTblColumna()
                        this.columna = ""
                        this.columnaName = ""
                    }, 3000);
                })
        },

        reloadTblColumna() {
            this.$emit('reloadTblColumna', false)
        }
    }
}
</script>

<style src="../main.css"></style>